import React, { useEffect, useState } from 'react';
import { accountStatus, loginUser, registerUser } from '../../../utils/login';
import FormBottomBar from './FormBottomBar';
import Chevron from './Chevron';

// «Ets tu?» on the web form: someone of the colla logs in with their password (or
// makes one, as the app's «Contrasenya nova»), and the form opens as them, with
// the answer they already sent from the app. The session stays in this browser,
// as the web's own login (utils/login.js), so the next forms open as them too.
const MIN_NEW_PASSWORD = 6;

const MemberLogin = ({ member, onBack, onLoggedIn = () => window.location.reload() }) => {
  const [account, setAccount] = useState(undefined);
  const [password, setPassword] = useState('');
  const [state, setState] = useState('idle');
  const [error, setError] = useState(null);

  useEffect(() => {
    let current = true;
    accountStatus(member.id)
      .then((status) => { if (current) setAccount(status); })
      .catch(() => { if (current) setAccount({ hasPassword: true, requiresCollaReset: false }); });
    return () => { current = false; };
  }, [member.id]);

  const creating = account?.hasPassword === false;
  const usable = account && !account.requiresCollaReset;
  const ready = usable && state !== 'sending' && (creating ? password.length >= MIN_NEW_PASSWORD : password.length > 0);

  const submit = async () => {
    if (!ready) return;
    setState('sending');
    setError(null);
    const done = creating ? await registerUser(member.id, password) : await loginUser(member.id, password);
    if (done) {
      onLoggedIn();
      return;
    }
    setState('idle');
    setError(creating ? "No s'ha pogut crear la contrasenya. Torna-ho a provar." : 'La contrasenya no és correcta.');
  };

  return (
    <>
      <button type="button" className="form-back-link" onClick={onBack} disabled={state === 'sending'}>
        <span aria-hidden="true">←</span> No sóc jo
      </button>
      <h1>{member.name}</h1>
      <p>
        {account === undefined ? 'Un moment...'
          : account === null || account.requiresCollaReset ? "Aquest usuari s'ha de tornar a activar des de l'app."
          : creating ? "Encara no tens contrasenya. Crea'n una per entrar: també et servirà a l'app."
          : "Entra amb la teva contrasenya de l'Aleta, la mateixa de l'app."}
      </p>
      {usable ? (
        <form
          className="form-element-container"
          onSubmit={(event) => {
            event.preventDefault();
            submit();
          }}
        >
          {/* For the browser's saved passwords, as the app's: «Nom Cognom (Mote)» */}
          <input
            type="text"
            name="username"
            autoComplete="username"
            value={member.mote && member.mote !== member.name ? `${member.name} (${member.mote})` : member.name}
            readOnly
            hidden
          />
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder={creating ? `Contrasenya nova (${MIN_NEW_PASSWORD} caràcters o més)` : 'Contrasenya'}
            aria-label={creating ? 'Contrasenya nova' : 'Contrasenya'}
            autoComplete={creating ? 'new-password' : 'current-password'}
            autoFocus
          />
          {error ? <div className="form-error-text">{error}</div> : null}
          {creating ? null : <div className="form-question-hint form-login-hint">No la recordes? Demana a la junta que te la canviï.</div>}
        </form>
      ) : null}
      <FormBottomBar>
        {usable ? (
          <button
            type="button"
            onClick={submit}
            disabled={state === 'sending'}
            aria-disabled={!ready}
            className={`editable-form-button${ready || state === 'sending' ? '' : ' editable-form-button-blocked'}`}
          >
            {state === 'sending' ? 'Entrant...' : (
              <span className="form-button-label">{creating ? 'Crea la contrasenya' : 'Entra'}<Chevron /></span>
            )}
          </button>
        ) : (
          <button type="button" onClick={onBack} className="editable-form-button editable-form-button-reset">
            Respon sense entrar
          </button>
        )}
      </FormBottomBar>
    </>
  );
};

export default MemberLogin;
